<div class="col-lg-12">
  <div class="card">
    <div class="card-body">

      <div class="row">
        <div class="col-sm-12">

          <ul class="nav nav-tabs nav-tabs-custom" role="tablist" id="ulTabList">
            <li class="nav-item" id="liTTPSumTab" *ngIf="TTPTab==true">
              <a class="nav-link active" data-bs-toggle="tab" href="#tabTTP" role="tab" title="Article Time To Publish" (click)="EnableMonthList()">
                Article TTP Report
              </a>
            </li>
            <li class="nav-item" id="liPMWiseTab" *ngIf="PMWiseTab==true">
              <a class="nav-link" data-bs-toggle="tab" href="#tabPMWise" role="tab" title="Article Project Manager Wise" (click)="EnableMonthList()">
                Article TTP Project Manager Report
              </a>
            </li>
            <li class="nav-item" id="liTTPIssTab" *ngIf="TTPIssueTab==true">
              <a class="nav-link" data-bs-toggle="tab" href="#tabTTPIssue" role="tab" title="Issue Time To Publish" (click)="EnableMonthList()">
                Issue TTP Report
              </a>
            </li>
            <li class="nav-item" id="liIssPMWiseTab" *ngIf="IssPMWiseTab==true">
              <a class="nav-link" data-bs-toggle="tab" href="#tabIssPMWise" role="tab" title="Issue Project Manager wise" (click)="EnableMonthList()">
                Issue Project Manager Report
              </a>
            </li>
            <li class="nav-item" id="liFeedbackTab" *ngIf="TTPFeedbackTab==true">
              <a class="nav-link" data-bs-toggle="tab" href="#tabIssFeedBack" role="tab" title="Feedback" (click)="EnableMonthList()">
                Feedback Report
              </a>
            </li>
            <li class="nav-item" id="liWIPTab" *ngIf="TTPWIPTab==true">
              <a class="nav-link" data-bs-toggle="tab" href="#tabWIPArticle" role="tab" title="Work in Progress" (click)="EnableMonthList()">
                WIP Report
              </a>
            </li>
          </ul>
          <div class="tab-content">
            <div class="row" id="divFilterList">
              <div class="col-sm-4" id="yearList">
                <button type="button" id="Btn2025" class="btn btn-outline-info waves-effect waves-light clsMargin Year active" (click)="getFiltered('2025',1)">2025</button>
                <button type="button" id="Btn2024" class="btn btn-outline-info waves-effect waves-light clsMargin Year" (click)="getFiltered('2024',1)">2024</button>
                <button type="button" id="Btn2023" class="btn btn-outline-info waves-effect waves-light clsMargin Year" (click)="getFiltered('2023',1)">2023</button>
                <button type="button" id="Btn2022" class="btn btn-outline-info waves-effect waves-light clsMargin Year" (click)="getFiltered('2022',1)">2022</button>
              </div>
              <div class="col-sm-8" id="MonthList">
                <button type="button" id="BtnJan" class="btn btn-outline-info waves-effect waves-light clsMargin month active" (click)="getFiltered('',1)">Jan</button>
                <button type="button" id="BtnFeb" class="btn btn-outline-info waves-effect waves-light clsMargin month" (click)="getFiltered('',2)">Feb</button>
                <button type="button" id="BtnMar" class="btn btn-outline-info waves-effect waves-light clsMargin month" (click)="getFiltered('',3)">Mar</button>
                <button type="button" id="BtnApr" class="btn btn-outline-info waves-effect waves-light clsMargin month" (click)="getFiltered('',4)">Apr</button>
                <button type="button" id="BtnMay" class="btn btn-outline-info waves-effect waves-light clsMargin month" (click)="getFiltered('',5)">May</button>
                <button type="button" id="BtnJun" class="btn btn-outline-info waves-effect waves-light clsMargin month" (click)="getFiltered('',6)">Jun</button>
                <button type="button" id="BtnJul" class="btn btn-outline-info waves-effect waves-light clsMargin month" (click)="getFiltered('',7)">July</button>
                <button type="button" id="BtnAug" class="btn btn-outline-info waves-effect waves-light clsMargin month" (click)="getFiltered('',8)">Aug</button>
                <button type="button" id="BtnSep" class="btn btn-outline-info waves-effect waves-light clsMargin month" (click)="getFiltered('',9)">Sep</button>
                <button type="button" id="BtnOct" class="btn btn-outline-info waves-effect waves-light clsMargin month" (click)="getFiltered('',10)">Oct</button>
                <button type="button" id="BtnNov" class="btn btn-outline-info waves-effect waves-light clsMargin month" (click)="getFiltered('',11)">Nov</button>
                <button type="button" id="BtnDec" class="btn btn-outline-info waves-effect waves-light clsMargin month" (click)="getFiltered('',12)">Dec</button>
              </div>
            </div>
            <div id="tabTTP" class="tab-pane active" style="overflow: hidden; overflow-y: auto;">
              <div class="row col">
                <div id="divFilter" class="row">
                  <div class="col-sm-12">
                    <highcharts-chart [Highcharts]="highchartsArt"
                                      [options]="chartOptionsArt"
                                      style="width: 100%; height: 400px; display: block;">
                    </highcharts-chart>
                    <br /><hr /><br />
                  </div>
                </div>
              </div>
            </div>
            <div id="tabPMWise" class="tab-pane" style="overflow: hidden; overflow-y: auto;">
              <div class="row col">
                <div id="divFilter" class="row">
                  <div class="col-sm-12">
                    <highcharts-chart [Highcharts]="highchartsArtPM"
                                      [options]="chartOptionsArtPM"
                                      style="width: 100%; height: 400px; display: block;">
                    </highcharts-chart>
                    <br /><hr /><br />
                  </div>
                </div>
              </div>
            </div>
            <div id="tabTTPIssue" class="tab-pane" style="overflow: hidden; overflow-y: auto;">
              <div class="row col">
                <div id="divFilter" class="row">
                  <div class="col-sm-12">
                    <highcharts-chart [Highcharts]="highchartsIss"
                                      [options]="chartOptionsIss"
                                      style="width: 100%; height: 400px; display: block;">
                    </highcharts-chart>
                    <br /><hr /><br />
                  </div>
                </div>
              </div>
            </div>
            <div id="tabIssPMWise" class="tab-pane" style="overflow: hidden; overflow-y: auto;">
              <div class="row col">
                <div id="divFilter" class="row">
                  <div class="col-sm-12">
                    <highcharts-chart [Highcharts]="highchartsIssPM"
                                      [options]="chartOptionsIssPM"
                                      style="width: 100%; height: 400px; display: block;">
                    </highcharts-chart>
                    <br /><hr /><br />
                  </div>
                </div>
              </div>
            </div>
            <div id="tabIssFeedBack" class="tab-pane" style="overflow: hidden; overflow-y: auto;">
              <div class="row col">
                <div id="divFilter" class="row">
                  <div class="col-sm-12">
                    <highcharts-chart [Highcharts]="highchartsFeed"
                                      [options]="chartOptionsFeed"
                                      style="width: 100%; height: 400px; display: block;">
                    </highcharts-chart>
                    <br /><hr /><br />
                  </div>
                </div>
              </div>
            </div>

            <div id="tabWIPArticle" class="tab-pane" style="overflow: hidden; overflow-y: auto;">
              <div class="row col">
                <div id="divFilter" class="row">
                  <!--<div class="col-sm-12">
                    <div id="tabDashboard" class="tab-pane active">
                      <div class="row" id="divSummaryIndex">
                        <div class="col-12 col-sm-6 col-md-3">
                          <div class="info-box">
                            <span class="info-box-icon bg-info elevation-1"><i class="fas fa-cogs"></i></span>
                            <div class="info-box-content">
                              <span class="info-box-text">Total WIP</span>
                              <span class="info-box-number">{{WIPCt}}</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-3">
                          <div class="info-box mb-3">
                            <span class="info-box-icon bg-danger elevation-1"><i class="fa fa-book"></i></span>
                            <div class="info-box-content">
                              <span class="info-box-text">On Hold</span>
                              <span class="info-box-number">{{HoldCount}}</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-3">
                          <div class="info-box mb-3">
                            <span class="info-box-icon bg-success elevation-1"><i class="fa fa-download"></i></span>
                            <div class="info-box-content">
                              <span class="info-box-text">OverDue</span>
                              <span class="info-box-number">{{Overdue}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>-->
                  <div class="col-sm-4">
                    <div class="row">
                    <br />
                    <br />
                    </div>
                    <table>
                      <thead>
                        <tr>
                          <th>
                            <h6 class="mb-1">Stage</h6>
                          </th>
                          <th>
                            <h6 class="mb-1">WIP</h6>
                          </th>
                          <th>
                            <h6 class="mb-1">On Hold</h6>
                          </th>
                          <th>
                            <h6 class="mb-1">OverDue</h6>
                          </th>
                        </tr>
                      </thead>
                      <tbody *ngFor="let item of modelData.WIPSummary">
                        <tr>
                          <td class="High">
                            <h6 class="mb-1">{{item.WipSumHead}}</h6>
                          </td>
                          <td>
                            <h5 class="small-box-footer spFilter">{{item.WIP}}</h5>
                          </td>
                          <td>
                            <h5 class="small-box-footer spFilter">{{item.Hold}}</h5>
                          </td>
                          <td>
                            <h5 class="small-box-footer spFilter">{{item.Overdue}}</h5>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="row" style="white-space:nowrap;display:none;padding:5px">
                      <div class="col-sm-3">
                        <h5 class="mb-1" data-id="Heading">Stage</h5>
                      </div>
                      <div class="col-sm-3" style="text-align:right;">
                        <h5 class="small-box-footer spFilter">
                          <span>WIP</span>
                        </h5>
                      </div>
                      <div class="col-sm-3" style="text-align:right;">
                        <h5 class="small-box-footer spFilter">
                          <span>On Hold</span>
                        </h5>
                      </div>
                      <div class="col-sm-3" style="text-align:right;">
                        <h5 class="small-box-footer spFilter">
                          <span>Overdue</span>
                        </h5>
                      </div>
                    </div>
                    <hr />
                    <div class="col-sm-12" id="divSummaryitem" style="display:none; overflow: hidden; overflow-y: auto; border: solid; border-width: 1px; padding-top: 10px;">
                      <div class="col" *ngFor="let item of modelData.WIPSummary">
                        <div class="row" style="padding:5px">
                          <div class="col-sm-3 btn btn-info">
                            <div class="info-box-content" style="word-wrap:break-word;">
                              <h6 class="mb-1" data-id="{{item.Id}}">{{item.WipSumHead}}</h6>
                            </div>
                          </div>
                          <div class="col-sm-3" style="text-align:right;">
                            <h5 class="small-box-footer spFilter" id="spanW{{item.Id}}"
                                attr.data-summaryname="{{item.WipSumHead}}">
                              <span>{{item.WIP}}</span>
                            </h5>
                          </div>
                          <div class="col-sm-3" style="text-align:right;">
                            <h5 class="small-box-footer spFilter" id="spanH{{item.Id}}"
                                attr.data-summaryname="{{item.WipSumHead}}">
                              <span>{{item.Hold}}</span>
                            </h5>
                          </div>
                          <div class="col-sm-3" style="text-align:right;">
                            <h5 class="small-box-footer spFilter" id="spanO{{item.Id}}"
                                attr.data-summaryname="{{item.WipSumHead}}">
                              <span>{{item.Overdue}}</span>
                            </h5>
                          </div>
                        </div>
                        <hr />
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-8">
                    <highcharts-chart [Highcharts]="highchartsWIP"
                                      [options]="chartOptionsWIP"
                                      style="width: 100%; height: 400px; display: block;">
                    </highcharts-chart>
                    <br /><hr /><br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="LoadingImage">
          <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
        </div>
      </div>
    </div>
  </div>
</div>
